export const FAQsIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M27.95 34.5C28.3 34.5 28.5958 34.3792 28.8375 34.1375C29.0792 33.8958 29.2 33.6 29.2 33.25C29.2 32.9 29.0792 32.6042 28.8375 32.3625C28.5958 32.1208 28.3 32 27.95 32C27.6 32 27.3042 32.1208 27.0625 32.3625C26.8208 32.6042 26.7 32.9 26.7 33.25C26.7 33.6 26.8208 33.8958 27.0625 34.1375C27.3042 34.3792 27.6 34.5 27.95 34.5ZM27.05 30.65H28.9C28.9 30.1 28.9625 29.6667 29.0875 29.35C29.2125 29.0333 29.5667 28.6 30.15 28.05C30.5833 27.6167 30.925 27.2042 31.175 26.8125C31.425 26.4208 31.55 25.95 31.55 25.4C31.55 24.4667 31.2083 23.75 30.525 23.25C29.8417 22.75 29.0333 22.5 28.1 22.5C27.15 22.5 26.3792 22.75 25.7875 23.25C25.1958 23.75 24.7833 24.35 24.55 25.05L26.2 25.7C26.2833 25.4 26.4708 25.075 26.7625 24.725C27.0542 24.375 27.5 24.2 28.1 24.2C28.6333 24.2 29.0333 24.3458 29.3 24.6375C29.5667 24.9292 29.7 25.25 29.7 25.6C29.7 25.9333 29.6 26.2458 29.4 26.5375C29.2 26.8292 28.95 27.1 28.65 27.35C27.9167 28 27.4667 28.4917 27.3 28.825C27.1333 29.1583 27.05 29.7667 27.05 30.65ZM28 38.5C26.6167 38.5 25.3167 38.2375 24.1 37.7125C22.8833 37.1875 21.825 36.475 20.925 35.575C20.025 34.675 19.3125 33.6167 18.7875 32.4C18.2625 31.1833 18 29.8833 18 28.5C18 27.1167 18.2625 25.8167 18.7875 24.6C19.3125 23.3833 20.025 22.325 20.925 21.425C21.825 20.525 22.8833 19.8125 24.1 19.2875C25.3167 18.7625 26.6167 18.5 28 18.5C29.3833 18.5 30.6833 18.7625 31.9 19.2875C33.1167 19.8125 34.175 20.525 35.075 21.425C35.975 22.325 36.6875 23.3833 37.2125 24.6C37.7375 25.8167 38 27.1167 38 28.5C38 29.8833 37.7375 31.1833 37.2125 32.4C36.6875 33.6167 35.975 34.675 35.075 35.575C34.175 36.475 33.1167 37.1875 31.9 37.7125C30.6833 38.2375 29.3833 38.5 28 38.5ZM28 36.5C30.2333 36.5 32.125 35.725 33.675 34.175C35.225 32.625 36 30.7333 36 28.5C36 26.2667 35.225 24.375 33.675 22.825C32.125 21.275 30.2333 20.5 28 20.5C25.7667 20.5 23.875 21.275 22.325 22.825C20.775 24.375 20 26.2667 20 28.5C20 30.7333 20.775 32.625 22.325 34.175C23.875 35.725 25.7667 36.5 28 36.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const RespFAQsIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <path
        d="M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM11.05 14.15H12.9C12.9 13.6 12.9625 13.1667 13.0875 12.85C13.2125 12.5333 13.5667 12.1 14.15 11.55C14.5833 11.1167 14.925 10.7042 15.175 10.3125C15.425 9.92083 15.55 9.45 15.55 8.9C15.55 7.96667 15.2083 7.25 14.525 6.75C13.8417 6.25 13.0333 6 12.1 6C11.15 6 10.3792 6.25 9.7875 6.75C9.19583 7.25 8.78333 7.85 8.55 8.55L10.2 9.2C10.2833 8.9 10.4708 8.575 10.7625 8.225C11.0542 7.875 11.5 7.7 12.1 7.7C12.6333 7.7 13.0333 7.84583 13.3 8.1375C13.5667 8.42917 13.7 8.75 13.7 9.1C13.7 9.43333 13.6 9.74583 13.4 10.0375C13.2 10.3292 12.95 10.6 12.65 10.85C11.9167 11.5 11.4667 11.9917 11.3 12.325C11.1333 12.6583 11.05 13.2667 11.05 14.15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
        fill={fill}
      />
    </svg>
  );
};

export const LegalPrivacyIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M8 18.5H16V16.5H8V18.5ZM8 14.5H16V12.5H8V14.5ZM6 22.5C5.45 22.5 4.97917 22.3042 4.5875 21.9125C4.19583 21.5208 4 21.05 4 20.5V4.5C4 3.95 4.19583 3.47917 4.5875 3.0875C4.97917 2.69583 5.45 2.5 6 2.5H14L20 8.5V20.5C20 21.05 19.8042 21.5208 19.4125 21.9125C19.0208 22.3042 18.55 22.5 18 22.5H6ZM13 9.5V4.5H6V20.5H18V9.5H13Z"
        fill={fill}
        transform="translate(15, 15)"
      />
    </svg>
  );
};

export const RespLegalPrivacyIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <rect
        width="24"
        height="24"
        transform="translate(0 0.5)"
        fill="#FAFAFA"
      />
      <path
        d="M8 18.5H16V16.5H8V18.5ZM8 14.5H16V12.5H8V14.5ZM6 22.5C5.45 22.5 4.97917 22.3042 4.5875 21.9125C4.19583 21.5208 4 21.05 4 20.5V4.5C4 3.95 4.19583 3.47917 4.5875 3.0875C4.97917 2.69583 5.45 2.5 6 2.5H14L20 8.5V20.5C20 21.05 19.8042 21.5208 19.4125 21.9125C19.0208 22.3042 18.55 22.5 18 22.5H6ZM13 9.5V4.5H6V20.5H18V9.5H13Z"
        fill={fill}
      />
    </svg>
  );
};

export const SignOutIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M5 21.5C4.45 21.5 3.97917 21.3042 3.5875 20.9125C3.19583 20.5208 3 20.05 3 19.5V5.5C3 4.95 3.19583 4.47917 3.5875 4.0875C3.97917 3.69583 4.45 3.5 5 3.5H12V5.5H5V19.5H12V21.5H5ZM16 17.5L14.625 16.05L17.175 13.5H9V11.5H17.175L14.625 8.95L16 7.5L21 12.5L16 17.5Z"
        fill={fill}
        transform="translate(15, 15)"
      />
    </svg>
  );
};
